import { OOO_STATE_OPTIONS_LIST, REASSIGNMENT_TYPE } from '@/constants/ooo';

export const REASSIGNMENT_STATE_OPTIONS_LIST = OOO_STATE_OPTIONS_LIST;
export { REASSIGNMENT_TYPE };

export const REASSIGNMENT_COLUMN_OPTIONS_LIST = [
  { value: 'status', text: 'Status' },
  { value: 'doctor', text: 'Source Doctor' },
  { value: 'state', text: 'State' },
  { value: 'reassignTo', text: 'Reassign To' },
  { value: 'startDate', text: 'Start Date' },
  { value: 'endDate', text: 'End Date' },
];

export const REASSIGNMENT_STATUS_OPTIONS_LIST = [
  { value: 'PENDING', text: 'Scheduled' },
  { value: 'ACTIVE', text: 'Active' },
  { value: 'RETURNED', text: 'Completed' },
  { value: 'CANCELLED', text: 'Cancelled' },
];

export const REASSIGNMENT_TABLE_HEADERS_LIST = [
  { key: 'assignmenttype', label: 'Reassignment Type', class: 'tw-w-[12%]' },
  { key: 'startdatestamp', label: 'Start Date', class: 'tw-w-[7%]' },
  { key: 'enddatestamp', label: 'End Date', class: 'tw-w-[7%]' },
  { key: 'name', label: 'Source Doctor', class: 'tw-w-[11%]' },
  { key: 'requeststatus', label: 'Status', class: 'tw-w-[6%]' },
  { key: 'coveredstate', label: 'State', class: 'tw-w-[9%]' },
  { key: 'doctorlistdetails', label: 'Reassign To', class: 'tw-w-[12%]' },
  { key: 'actions', label: 'Actions', class: 'tw-w-[15%]' },
  { key: 'requestedby', label: 'Requested by', class: 'tw-w-[9%]' },
  { key: 'notes', label: 'Request Notes', class: 'tw-w-[12%]' },
];
